import { bem, noop } from '@socialive/common';
import PropTypes from 'prop-types';
import CheckedIcon from '../../Icons/CheckedIcon';
import UncheckedIcon from '../../Icons/UncheckedIcon';
import './radio.css';

/*
#tailwind
radio radio--checked radio--unchecked radio--disabled
*/

const Radio = ({ children, name, checked, disabled, readOnly, onClick, onFocus, onBlur, ...other }) => (
  <label
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    tabIndex="0"
    className={bem`radio--${{
      checked,
      unchecked: !checked,
      disabled,
    }}`}
    onClick={onClick}
    {...other}
  >
    <input
      checked={checked}
      disabled={disabled}
      // eslint-disable-next-line no-restricted-globals
      name={name}
      type="radio"
      readOnly={readOnly}
      onChange={noop}
      onFocus={onFocus}
      onBlur={onBlur}
      className="radio__input"
      tabIndex="-1"
    />
    {checked ? (
      <CheckedIcon size="1rem" className="radio__icon" />
    ) : (
      <UncheckedIcon size="1rem" className="radio__icon" />
    )}
    {children}
  </label>
);

Radio.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
  checked: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

Radio.defaultProps = {
  children: undefined,
  name: undefined,
  checked: false,
  readOnly: false,
  disabled: false,
  onClick: undefined,
  onFocus: undefined,
  onBlur: undefined,
};

export default Radio;
